export var ActivityKind;
(function (ActivityKind) {
    ActivityKind["NowViewing"] = "nowViewing";
    ActivityKind["TodayViewed"] = "todayViewed";
    ActivityKind["BookedToday"] = "bookedToday";
    ActivityKind["LastReservation"] = "lastReservation";
    ActivityKind["DiscountToday"] = "discountToday";
    ActivityKind["TodaySpecialOffer"] = "todaySpecialOffer";
})(ActivityKind || (ActivityKind = {}));
//# sourceMappingURL=activity.types.js.map